// extracted by mini-css-extract-plugin
export var card = "_v4-0";
export var details = "_v4-1";